import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';
import { useSettingsContext } from '../contexts/settings';

const FiltersBar = ({ children }) => {
	const { tax } = useFiltersContext();
	const settings = useSettingsContext();

	const taxEntries = Object.entries(tax);

	if (taxEntries.length || settings.showSearch) {
		return (
			<div className="pfa-filters-bar">
				<h2
					className="pfa-filters-bar__title"
					dangerouslySetInnerHTML={{ __html: settings.searchTitle }}
				/>
				{children}
			</div>
		);
	} else if (settings.searchTitle.length) {
		return (
			<div className="pfa-filters-bar">
				<h2
					className="pfa-filters-bar__title"
					dangerouslySetInnerHTML={{ __html: settings.searchTitle }}
				/>
			</div>
		);
	}

	return '';
};

FiltersBar.displayName = 'FiltersBar';

export default FiltersBar;
